// Confirms before the user leaves the current view while `shouldGuard()` is true.
// Guards full-page exits (reload, tab close, Turbo Drive) via beforeunload, and in-app
// navigations — link clicks — via a capture-phase interception.
// Returns a teardown function the caller MUST invoke on disconnect.
export function guardNavigation({ shouldGuard, message, onLeave }) {
  const confirmLeave = (event) => {
    if (!shouldGuard()) return;

    event.preventDefault();
    event.returnValue = '';
  };

  const confirmIntent = (event) => {
    if (!shouldGuard() || !navigatesAway(event)) return;

    if (window.confirm(message)) {
      onLeave?.();
    } else {
      event.preventDefault();
      event.stopImmediatePropagation();
    }
  };

  window.addEventListener('beforeunload', confirmLeave);
  document.addEventListener('click', confirmIntent, true);

  return () => {
    window.removeEventListener('beforeunload', confirmLeave);
    document.removeEventListener('click', confirmIntent, true);
  };
}

function navigatesAway(event) {
  if (event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return false;

  const link = event.target.closest('a[href]');
  return !!link && link.target !== '_blank' && !link.hasAttribute('download');
}
